// extracted by mini-css-extract-plugin
export default {"dashboard":"HomePage_dashboard__JG5Qa","left":"HomePage_left__lDZvK","right":"HomePage_right__jVces","pair":"HomePage_pair__fjCnv"};